import { getPortalBasename } from './metadata';
export function buildLoginRedirectUrl(redirectUrl) {
  var _getPortalBasename;
  const destination = redirectUrl !== null && redirectUrl !== void 0 ? redirectUrl : `${window.location.origin}${(_getPortalBasename = getPortalBasename()) !== null && _getPortalBasename !== void 0 ? _getPortalBasename : '/'}`;
  return `/_hcms/mem/login?redirect_url=${encodeURIComponent(destination)}`;
}
export function redirectToLogin(redirectUrl) {
  window.location.href = buildLoginRedirectUrl(redirectUrl);
}